import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import { getPersonalizedProducts } from "./personalizedProducts.thunk";
import { resetPersonalizedProducts } from "./personalizedProducts.slice";

const usePersonalizedProducts = () => {
  const dispatch = useAppDispatch();
  const { groups, status, error } = useAppSelector(
    (state) => state.personalizedProducts,
  );

  const fetchPersonalizedProducts = useCallback(() => {
    dispatch(getPersonalizedProducts());
  }, [dispatch]);

  const reset = useCallback(() => {
    dispatch(resetPersonalizedProducts());
  }, [dispatch]);

  return {
    groups,
    isLoading: status === "loading",
    isSuccess: status === "success",
    isError: status === "error",
    error,
    fetchPersonalizedProducts,
    reset,
  };
};

export default usePersonalizedProducts;